export default "__VITE_ASSET__CiL78uds__"